import { render, staticRenderFns } from "./monthrecdetail.vue?vue&type=template&id=6cc805aa&scoped=true&"
import script from "./monthrecdetail.vue?vue&type=script&lang=js&"
export * from "./monthrecdetail.vue?vue&type=script&lang=js&"
import style0 from "./monthrecdetail.vue?vue&type=style&index=0&id=6cc805aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc805aa",
  null
  
)

export default component.exports